<form #mapForm="ngForm" autocomplete="off" class="routing-rule-dialog">
    <div class="routing-rule-dialog-container">
        <div class="routing-rule-dialog-header">
            <mat-form-field class="rule-name">
                <mat-label>Name</mat-label>
                <input matInput required [(ngModel)]="rule.name" maxlength="255" name="name">
                <mat-error>
                    Name is <strong>required</strong>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="group-name">
                <mat-label>Group</mat-label>
                <input matInput required disabled [(ngModel)]="groupName" maxlength="255" name="group">
            </mat-form-field>
        </div>
        <div class="admin-state-buttons">
            <button mat-flat-button color="primary" class="toolbar-button"
                    [class.active]="rule.adminStateBoolean"
                    (click)="switchAdminState()">Live</button>
            <button mat-flat-button color="primary" class="toolbar-button"
                    [class.active]="rule.testModeBoolean"
                    (click)="switchTestMode()">Test</button>
        </div>
        <div class="rule-details-content">
            <ac-tabs tabsId="rule-settings-tab-set" (onSelect)="onTabSelect($event)">
                <routing-rule-dialog-source *acTab="'Source'; id: 'source-tab'"
                                            class="routing-rule-tab"
                                            [source]="rule.source"
                                            [externalData]="externalData"
                                            [adminState]="rule.adminState">
                </routing-rule-dialog-source>
                <routing-rule-dialog-destination *acTab="'Destination'; id: 'destination-tab'"
                                                 class="routing-rule-tab"
                                                 [destination]="rule.destination"
                                                 [externalData]="externalData">
                </routing-rule-dialog-destination>
                <routing-rule-dialog-advanced-condition *acTab="'Advanced Conditions'; id: 'advanced-conditions-tab', isValid: isAdvanceConditionValid"
                                                        class="routing-rule-tab"
                                                        [rule]="rule"
                                                        [isSipHeaderValid] ="isSipHeaderValid"
                                                        [isTagValid] ="isTagValid"
                                                        [externalData]="externalData">
                </routing-rule-dialog-advanced-condition>
                <routing-rule-dialog-routing-actions *acTab="'Routing Actions'; id: 'routing-actions-tab', isValid: isRoutingActionsValid"
                                                     class="routing-rule-tab"
                                                     [rule]="rule"
                                                     [isValid]="isRoutingActionsValid"
                                                     [externalData]="externalData"
                                                     [adminState]="rule.adminState">
                </routing-rule-dialog-routing-actions>
            </ac-tabs>
        </div>
    </div>
    <div class="map-container"></div>
</form>
